var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_10234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3055 0H10.6946C4.78745 0 0 4.78216 0 10.6827V53.2466C0 59.1471 4.78745 63.9293 10.6946 63.9293H53.3055C59.2125 63.9293 64 59.1471 64 53.2466V10.6827C64 4.78216 59.2125 0 53.3055 0ZM52.366 48.9336C52.366 50.7976 50.8538 52.3081 48.9877 52.3081H15.0123C13.1462 52.3081 11.634 50.7976 11.634 48.9336V14.9957C11.634 13.1317 13.1462 11.6212 15.0123 11.6212H48.9877C50.8538 11.6212 52.366 13.1317 52.366 14.9957V48.9336ZM25.2113 40.642C24.1367 40.642 23.2745 39.7742 23.2745 38.7008V25.1514C23.2745 24.0779 24.1367 23.2038 25.2113 23.2038H38.7951C39.8633 23.2038 40.732 24.0715 40.732 25.1514V38.6944C40.732 39.7678 39.8633 40.6355 38.7951 40.6355H25.2113V40.642Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_10234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/square-logo.bc8fe665ad52152d43e4adb597e5f7d1.svg";
export { ForwardRef as ReactComponent };